import client from 'data/client';
import { WorkingHoursData } from 'data/types/workingHours';
import { normalizeWorkingHours } from 'model/workingHours';

const getWorkingHours = async (brandId: string) => {
  const response = await client.get<WorkingHoursData>(
    `/settings/timings?brandId=${brandId}`,
  );

  return normalizeWorkingHours(response.data);
};

export default getWorkingHours;
